module.exports = __webpack_public_path__ + "components/flag/static/square/lv-37f158e84fc70df4fc8fb3c2d854d231.svg";